export const Banner = () => (
  <div className="h-full w-full rounded-lg border border-border/primary flex flex-col xl:flex-row overflow-hidden">
    <svg
      className="w-full h-full "
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2054_109356)">
        <path
          d="M0 7.99998C0 3.5817 3.58172 0 8 0H874C878.418 0 882 3.58172 882 8V1005C882 1009.42 878.418 1013 874 1013H7.99998C3.58171 1013 0 1009.42 0 1005V7.99998Z"
          fill="#55585A"
        />
        <mask
          height="1179"
          id="mask0_2054_109356"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="1178"
          x="0"
          y="-83"
        >
          <path
            d="M5.3522 1089.83H1172.6V-76.8262H5.3522V1089.83Z"
            fill="white"
            stroke="white"
            strokeWidth="10.7044"
          />
        </mask>
        <g mask="url(#mask0_2054_109356)">
          <path
            d="M260.82 993.773C354.505 1057.04 467.437 1093.97 588.985 1093.97C913.275 1093.97 1176.16 831.087 1176.16 506.797C1176.16 385.238 1139.22 272.317 1075.96 178.632M102.01 834.962C38.7466 741.266 1.80566 628.346 1.80566 506.797C1.80566 182.507 264.695 -80.3825 588.985 -80.3825C710.534 -80.3825 823.465 -43.4416 917.15 19.8107M933.582 530.743C938.259 464.408 923.862 396.017 888.109 334.092C792.733 168.891 581.492 112.286 416.291 207.673C354.366 243.426 307.706 295.449 278.579 355.233M899.392 658.35C870.265 718.134 823.605 770.168 761.68 805.921C596.478 901.297 385.238 844.692 289.861 679.491C254.109 617.566 239.711 549.176 244.389 482.851M757.494 620.349C779.385 587.926 792.166 548.855 792.166 506.797C792.166 394.583 701.2 303.617 588.985 303.617C546.928 303.617 507.857 316.398 475.433 338.288M702.538 675.295C670.125 697.186 631.043 709.967 588.985 709.967C476.771 709.967 385.805 619.001 385.805 506.797C385.805 464.729 398.597 425.658 420.476 393.245M641.426 614.205C662.118 604.122 680.112 587.979 692.486 566.549C725.488 509.388 705.91 436.298 648.748 403.296C627.318 390.922 603.65 385.934 580.7 387.55M597.27 626.033C574.32 627.65 550.653 622.672 529.233 610.298C472.061 577.296 452.483 504.196 485.484 447.034C497.848 425.615 515.853 409.462 536.544 399.389M584.115 576.932C597.613 577.885 611.529 574.952 624.139 567.673C657.761 548.266 669.279 505.266 649.872 471.644C642.593 459.045 632.006 449.539 619.835 443.609M558.135 569.974C545.964 564.044 535.378 554.549 528.099 541.94C508.692 508.317 520.209 465.328 553.832 445.91C566.442 438.631 580.358 435.698 593.856 436.651M565.874 541.094C572.468 545.547 580.422 548.148 588.985 548.148C611.829 548.148 630.336 529.63 630.336 506.797C630.336 498.234 627.735 490.28 623.282 483.686M554.688 529.908C550.235 523.303 547.634 515.35 547.634 506.797C547.634 483.954 566.142 465.435 588.985 465.435C597.549 465.435 605.502 468.036 612.096 472.5"
            stroke="white"
            strokeWidth="0.4"
          />
        </g>
      </g>
      <path
        d="M0.5 7.99998C0.5 3.85785 3.85786 0.5 8 0.5H874C878.142 0.5 881.5 3.85787 881.5 8V1005C881.5 1009.14 878.142 1012.5 874 1012.5H7.99998C3.85785 1012.5 0.5 1009.14 0.5 1005V7.99998Z"
        stroke="#DEE1E5"
      />
      <defs>
        <clipPath id="clip0_2054_109356">
          <path
            d="M0 7.99998C0 3.5817 3.58172 0 8 0H874C878.418 0 882 3.58172 882 8V1005C882 1009.42 878.418 1013 874 1013H7.99998C3.58171 1013 0 1009.42 0 1005V7.99998Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);
